import React,{useEffect} from 'react'
import PageUnderDevelopement from '../../../PageUnderDevelopement'


const  KonguCRS= () => {
    useEffect(() => {
        window.location.href = "https://kongu.ac.in/kongu.ac.in/kongucrs/";
      }, []);
    
  return (
    <div>
        {/* <PageUnderDevelopement/> */}
        
    </div>
  )
}

export default KonguCRS 